// Nanda Diagnostics Mock Data
// Brand Color: #007897 (Teal Blue from logo)

export const companyInfo = {
  name: "Nanda Diagnostics",
  tagline: "",
  description: "Nanda Diagnostics is a diagnostic center accredited for its innovation and merits. Since our inception in 1992, we have successfully developed into a diagnostic center of excellence in the field of radiology and pathology by adopting latest techniques, employing highly skilled professionals and introducing latest state of art equipment.",
  address: "C-566, Outer Ring Road, Saraswati Vihar, Pitam Pura, Delhi – 110034",
  phones: ["011-47500500", "011-46102349", "011-47046355", "+91-9953852212"],
  whatsapp: "+91-9953852212",
  email: "info@nandadiagnostics.com",
  mapUrl: "https://maps.app.goo.gl/s7P5qjNoimHRueF37",
  timings: {
    weekdays: "Mon - Sat: 8:00 AM - 8:00 PM",
    sunday: "Sunday: 8:00 AM - 1:00 PM"
  },
  socialMedia: {
    facebook: "https://www.facebook.com/diagnosticsnanda/",
    twitter: "https://twitter.com/diagnosticnanda",
    instagram: "https://www.instagram.com/nandadiagnostics/",
    youtube: "https://www.youtube.com/@nandadiagnostics"
  },
  stats: {
    patients: "100k+",
    tests: "1000k+",
    yearsExperience: "32+",
    specialists: "50+"
  },
  logo: "/assets/nanda-logo.png"
};

export const features = [
  {
    id: 1,
    title: "Trusted & Ethical",
    description: "Over 32 years of trusted healthcare services",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Skilled Professionals",
    description: "Highly qualified and experienced team",
    icon: "Users"
  },
  {
    id: 3,
    title: "Latest Technology",
    description: "Latest state-of-art diagnostic equipment",
    icon: "Cpu"
  },
  {
    id: 4,
    title: "Accredited Lab Services",
    description: "NABL accredited laboratory with quality assurance",
    icon: "Building2"
  },
  {
    id: 5,
    title: "Fast & Accurate Results",
    description: "Quick turnaround time with precise diagnostic results",
    icon: "Zap"
  }
];

export const services = [
  {
    id: 1,
    name: "Laboratory Services",
    slug: "laboratory",
    description: "Comprehensive pathology tests including biochemistry, hematology, microbiology, and immunology.",
    icon: "FlaskConical",
    category: "Pathology",
    subServices: [
      {
        name: "Medical Biochemistry",
        slug: "biochemistry",
        description: "Complete biochemical analysis for metabolic disorders and organ function.",
        tests: [
          { name: "Liver Function Tests (LFT)", description: "Assesses liver health including bilirubin, SGOT, SGPT, ALP" },
          { name: "Kidney Function Tests (KFT)", description: "Evaluates kidney function with urea, creatinine, uric acid" },
          { name: "Lipid Profile", description: "Complete cholesterol panel including HDL, LDL, triglycerides" },
          { name: "Blood Sugar (Fasting/PP/Random)", description: "Glucose level monitoring for diabetes" },
          { name: "HbA1c", description: "3-month average blood sugar indicator" },
          { name: "Thyroid Profile (T3, T4, TSH)", description: "Complete thyroid function assessment" },
          { name: "Electrolytes", description: "Sodium, potassium, chloride levels" },
          { name: "Calcium & Phosphorus", description: "Bone health and metabolism markers" },
          { name: "Iron Studies", description: "Serum iron, TIBC, ferritin for anemia evaluation" },
          { name: "Vitamin D", description: "25-OH Vitamin D level assessment" },
          { name: "Vitamin B12", description: "Essential for nerve function and blood formation" }
        ]
      },
      {
        name: "Hematology",
        slug: "hematology",
        description: "Blood cell analysis and coagulation studies.",
        tests: [
          { name: "Complete Blood Count (CBC)", description: "RBC, WBC, platelets, hemoglobin analysis" },
          { name: "ESR", description: "Erythrocyte sedimentation rate for inflammation" },
          { name: "Peripheral Blood Smear", description: "Microscopic blood cell examination" },
          { name: "Reticulocyte Count", description: "Young red blood cell assessment" },
          { name: "Coagulation Profile (PT/INR, aPTT)", description: "Blood clotting assessment" },
          { name: "Bleeding Time & Clotting Time", description: "Basic clotting function tests" },
          { name: "D-Dimer", description: "Blood clot marker" }
        ]
      },
      {
        name: "Microbiology",
        slug: "microbiology",
        description: "Culture and sensitivity testing for infections.",
        tests: [
          { name: "Urine Culture & Sensitivity", description: "Urinary tract infection diagnosis" },
          { name: "Blood Culture", description: "Bloodstream infection detection" },
          { name: "Stool Culture", description: "Gastrointestinal infection testing" },
          { name: "Sputum Culture", description: "Respiratory infection diagnosis" },
          { name: "Wound Swab Culture", description: "Wound infection analysis" },
          { name: "Throat Swab Culture", description: "Throat infection diagnosis" }
        ]
      },
      {
        name: "Immunology & Serology",
        slug: "immunology",
        description: "Immune system and antibody testing.",
        tests: [
          { name: "HIV 1 & 2", description: "Human immunodeficiency virus screening" },
          { name: "HBsAg", description: "Hepatitis B surface antigen" },
          { name: "HCV", description: "Hepatitis C virus antibody" },
          { name: "VDRL/RPR", description: "Syphilis screening" },
          { name: "Widal Test", description: "Typhoid fever detection" },
          { name: "Dengue NS1/IgG/IgM", description: "Dengue virus detection" },
          { name: "Malaria Antigen", description: "Malaria parasite detection" },
          { name: "RA Factor", description: "Rheumatoid arthritis marker" },
          { name: "CRP", description: "C-reactive protein for inflammation" },
          { name: "ASO Titre", description: "Streptococcal infection marker" },
          { name: "ANA", description: "Antinuclear antibody for autoimmune disorders" }
        ]
      },
      {
        name: "Cytology & Histopathology",
        slug: "histopathology",
        description: "Cell and tissue examination for diagnosis.",
        tests: [
          { name: "Pap Smear", description: "Cervical cancer screening" },
          { name: "FNAC", description: "Fine needle aspiration cytology" },
          { name: "Biopsy", description: "Tissue sample examination" },
          { name: "Fluid Cytology", description: "Body fluid cell analysis" }
        ]
      }
    ],
    tests: ["Medical Biochemistry", "Hematology", "Cytology & Histopathology", "Immunology", "Microbiology"]
  },
  {
    id: 2,
    name: "Radiology",
    slug: "radiology",
    description: "Complete radiology services including ultrasound, color doppler, digital X-ray, mammography, DEXA scan, and OPG.",
    icon: "Scan",
    category: "Radiology",
    subServices: [
      {
        name: "Ultrasound",
        slug: "ultrasound",
        description: "Advanced 3D/4D/5D ultrasound imaging with musculoskeletal capabilities.",
        tests: [
          { name: "Ultrasound Abdomen", description: "Liver, gallbladder, pancreas, spleen, kidneys imaging" },
          { name: "Ultrasound Pelvis", description: "Uterus, ovaries, bladder examination" },
          { name: "Ultrasound KUB", description: "Kidney, ureter, bladder assessment" },
          { name: "3D/4D Ultrasound", description: "Advanced fetal imaging during pregnancy" },
          { name: "5D Ultrasound", description: "Real-time fetal movement visualization" },
          { name: "NT Scan", description: "Nuchal translucency screening" },
          { name: "Anomaly Scan", description: "Detailed fetal anatomy evaluation" },
          { name: "Growth Scan", description: "Fetal growth monitoring" },
          { name: "Musculoskeletal Ultrasound", description: "Joint, muscle, tendon imaging" },
          { name: "Breast Ultrasound", description: "Breast tissue evaluation" },
          { name: "Thyroid Ultrasound", description: "Thyroid gland imaging" },
          { name: "Scrotal Ultrasound", description: "Testicular examination" }
        ]
      },
      {
        name: "Color Doppler Studies",
        slug: "doppler",
        description: "Non-invasive vascular imaging for comprehensive blood flow assessment.",
        tests: [
          { name: "Carotid Doppler", description: "Neck artery blood flow assessment" },
          { name: "Abdominal Doppler", description: "Abdominal vessel evaluation" },
          { name: "Renal Doppler", description: "Kidney blood flow assessment" },
          { name: "Peripheral Vascular Doppler", description: "Leg artery and vein assessment" },
          { name: "Venous Doppler (Lower/Upper Limb)", description: "Deep vein thrombosis detection" },
          { name: "AV Fistula Doppler", description: "Dialysis access evaluation" },
          { name: "Obstetric Doppler", description: "Fetal blood flow monitoring" },
          { name: "Penile Doppler", description: "Male reproductive health assessment" },
          { name: "Scrotal Doppler", description: "Testicular blood flow evaluation" }
        ]
      },
      {
        name: "Digital Imaging",
        slug: "xray",
        description: "Digital X-ray, Mammography, DEXA scan, Fibrotouch, and OPG services.",
        tests: [
          { name: "Digital X-ray (800 mA)", description: "High-quality digital radiography" },
          { name: "Fibrotouch", description: "Liver stiffness measurement for fibrosis" },
          { name: "Mammography", description: "Breast cancer screening" },
          { name: "DEXA Scan", description: "Bone mineral density measurement" },
          { name: "Digital OPG", description: "Panoramic dental X-ray" },
          { name: "HSG", description: "Hysterosalpingography for fertility assessment" }
        ]
      }
    ],
    tests: ["Ultrasound", "Color Doppler", "Digital X-ray", "DEXA", "Mammography", "Digital OPG"]
  },
  {
    id: 3,
    name: "Cardiology",
    slug: "cardiology",
    description: "Complete cardiac evaluation with ECHO, ECG, TMT, and stress tests.",
    icon: "HeartPulse",
    category: "Cardiology",
    subServices: [
      {
        name: "Cardiac Diagnostics",
        slug: "cardiac",
        description: "Comprehensive heart function assessment.",
        tests: [
          { name: "ECG (Electrocardiogram)", description: "Heart rhythm and electrical activity recording" },
          { name: "2D Echocardiography", description: "Heart structure and function imaging" },
          { name: "Color Doppler Echo", description: "Heart valve blood flow assessment" },
          { name: "TMT (Treadmill Test)", description: "Exercise stress test for heart" },
          { name: "Stress Echo", description: "Heart function under stress" },
          { name: "Dobutamine Stress Echo", description: "Pharmacological stress testing" },
          { name: "Holter Monitoring", description: "24-hour continuous ECG recording" },
          { name: "ABPM", description: "24-hour ambulatory blood pressure monitoring" }
        ]
      }
    ],
    tests: ["ECHO (Echocardiography)", "Holter, TMT, ECG", "Stress (Exercise & Dobutamine)"]
  },
  {
    id: 4,
    name: "Electrophysiology",
    slug: "electrophysiology",
    description: "Advanced neurological testing for brain and nerve function assessment.",
    icon: "BrainCircuit",
    category: "Neurology",
    subServices: [
      {
        name: "Neurophysiology Tests",
        slug: "neuro",
        description: "Brain and nerve function evaluation.",
        tests: [
          { name: "EEG (Electroencephalogram)", description: "Brain electrical activity recording" },
          { name: "EMG (Electromyography)", description: "Muscle electrical activity assessment" },
          { name: "NCV (Nerve Conduction Velocity)", description: "Nerve signal speed measurement" },
          { name: "VEP (Visual Evoked Potential)", description: "Visual pathway assessment" },
          { name: "BAER (Brainstem Auditory Evoked Response)", description: "Hearing pathway evaluation" },
          { name: "SSEP", description: "Somatosensory evoked potential" }
        ]
      }
    ],
    tests: ["EEG", "EMG", "NCV", "VEP", "BAER"]
  },
  {
    id: 5,
    name: "Pulmonary Function",
    slug: "pulmonary",
    description: "Comprehensive lung function testing for respiratory health evaluation.",
    icon: "Wind",
    category: "Respiratory",
    subServices: [
      {
        name: "Respiratory Tests",
        slug: "respiratory",
        description: "Lung capacity and function assessment.",
        tests: [
          { name: "Spirometry", description: "Basic lung function measurement" },
          { name: "PFT (Pulmonary Function Test)", description: "Comprehensive lung capacity assessment" },
          { name: "Bronchial Challenge Test", description: "Airway hyperresponsiveness testing" }
        ]
      }
    ],
    tests: ["Pulmonary Function Tests (PFT)"]
  }
];

// Updated packages based on latest Nanda Diagnostics website (January 2024)
export const packages = [
  // Advanced Wellness Packages
  {
    id: 1,
    name: "Gold Package",
    price: 2600,
    originalPrice: 4780,
    category: "Advanced Wellness",
    featured: true,
    tests: ["Haemogram", "LFT", "KFT", "Lipid Profile", "Blood Sugar Fasting", "HbA1C", "TSH", "Iron Profile", "CRP", "Urine Routine and Microscopy"]
  },
  {
    id: 2,
    name: "Silver Package",
    price: 1500,
    originalPrice: 3280,
    category: "Advanced Wellness",
    featured: true,
    tests: ["Haemogram", "LFT", "KFT", "Lipid Profile", "Blood Sugar Fasting", "TSH", "Urine Routine and Microscopy"]
  },
  {
    id: 3,
    name: "Ruby Package",
    price: 3700,
    originalPrice: 7530,
    category: "Advanced Wellness",
    featured: true,
    tests: ["Haemogram", "LFT", "KFT", "Lipid Profile", "Blood Sugar Fasting", "HbA1C", "Thyroid Function Tests (T3, T4, TSH)", "Iron Profile", "Vitamin D", "Vitamin B12", "Urine Routine and Microscopy"]
  },
  {
    id: 4,
    name: "Platinum Package",
    price: 3000,
    originalPrice: 6280,
    category: "Advanced Wellness",
    featured: true,
    tests: ["Haemogram", "LFT", "KFT", "Lipid Profile", "Blood Sugar Fasting", "HbA1C", "TSH", "Vitamin D", "Vitamin B12", "Urine Routine and Microscopy"]
  },
  // Smart Wellness Packages
  {
    id: 5,
    name: "Anaemia Panel",
    price: 4200,
    originalPrice: 5590,
    category: "Smart Wellness",
    featured: false,
    tests: ["CBC", "Iron Studies", "Vitamin B12", "Folic Acid", "Reticulocyte Count"]
  },
  {
    id: 6,
    name: "Antenatal Panel 1",
    price: 1800,
    originalPrice: 2380,
    category: "Smart Wellness",
    featured: false,
    tests: ["CBC", "Blood Group", "HIV", "HBsAg", "VDRL"]
  },
  {
    id: 7,
    name: "Antenatal Panel 2",
    price: 3400,
    originalPrice: 4580,
    category: "Smart Wellness",
    featured: false,
    tests: ["All Panel 1 Tests", "TSH", "Blood Sugar", "Urine Routine"]
  },
  {
    id: 8,
    name: "Antenatal Panel 3",
    price: 4700,
    originalPrice: 6230,
    category: "Smart Wellness",
    featured: false,
    tests: ["All Panel 2 Tests", "Thyroid Profile", "Vitamin D", "Vitamin B12"]
  },
  {
    id: 9,
    name: "Arthritis Panel",
    price: 2950,
    originalPrice: 3930,
    category: "Smart Wellness",
    featured: false,
    tests: ["RA Factor", "CRP", "ASO", "Uric Acid", "ESR"]
  },
  {
    id: 10,
    name: "Bone Health Panel",
    price: 2700,
    originalPrice: 3600,
    category: "Smart Wellness",
    featured: false,
    tests: ["Calcium", "Phosphorus", "Vitamin D", "PTH"]
  },
  {
    id: 11,
    name: "Diabetes Screening Panel",
    price: 1200,
    originalPrice: 1600,
    category: "Smart Wellness",
    featured: false,
    tests: ["Fasting Blood Sugar", "HbA1c", "Lipid Profile"]
  },
  {
    id: 12,
    name: "Diabetes Monitoring Panel",
    price: 2300,
    originalPrice: 3110,
    category: "Smart Wellness",
    featured: false,
    tests: ["HbA1c", "Fasting Blood Sugar", "Post Prandial", "Lipid Profile", "Kidney Function"]
  },
  {
    id: 13,
    name: "Fever Panel",
    price: 1250,
    originalPrice: 1690,
    category: "Smart Wellness",
    featured: false,
    tests: ["CBC", "Malaria", "Typhoid (Widal)", "Dengue NS1"]
  },
  {
    id: 14,
    name: "Fever Panel Extended",
    price: 2500,
    originalPrice: 3350,
    category: "Smart Wellness",
    featured: false,
    tests: ["All Fever Panel Tests", "LFT", "Dengue IgG/IgM", "Urine Routine"]
  },
  {
    id: 15,
    name: "Hypertension Panel",
    price: 1950,
    originalPrice: 2580,
    category: "Smart Wellness",
    featured: false,
    tests: ["Kidney Function", "Lipid Profile", "Electrolytes", "ECG"]
  },
  {
    id: 16,
    name: "PCOD Panel",
    price: 2350,
    originalPrice: 3140,
    category: "Smart Wellness",
    featured: false,
    tests: ["FSH", "LH", "Prolactin", "TSH", "Testosterone"]
  },
  {
    id: 17,
    name: "Thyroid Profile",
    price: 800,
    originalPrice: 1200,
    category: "Smart Wellness",
    featured: false,
    tests: ["T3", "T4", "TSH"]
  },
  {
    id: 18,
    name: "Cancer Profile (Female)",
    price: 4150,
    originalPrice: 5550,
    category: "Smart Wellness",
    featured: false,
    tests: ["CA 125", "CA 15.3", "CEA", "AFP", "Beta HCG"]
  },
  {
    id: 19,
    name: "Cancer Profile (Male)",
    price: 2750,
    originalPrice: 3650,
    category: "Smart Wellness",
    featured: false,
    tests: ["PSA", "CEA", "AFP"]
  },
  {
    id: 20,
    name: "Fertility Panel (Female)",
    price: 3200,
    originalPrice: 4250,
    category: "Smart Wellness",
    featured: false,
    tests: ["FSH", "LH", "Prolactin", "TSH", "AMH"]
  },
  {
    id: 21,
    name: "Fertility Panel (Male)",
    price: 2800,
    originalPrice: 3750,
    category: "Smart Wellness",
    featured: false,
    tests: ["Semen Analysis", "FSH", "LH", "Testosterone", "Prolactin"]
  },
  {
    id: 22,
    name: "Iron Profile",
    price: 1500,
    originalPrice: 2000,
    category: "Smart Wellness",
    featured: false,
    tests: ["Serum Iron", "TIBC", "Ferritin", "Transferrin Saturation"]
  },
  {
    id: 23,
    name: "Coagulation Profile",
    price: 1800,
    originalPrice: 2400,
    category: "Smart Wellness",
    featured: false,
    tests: ["PT/INR", "aPTT", "Bleeding Time", "Clotting Time"]
  },
  {
    id: 24,
    name: "Cervical Screening",
    price: 1650,
    originalPrice: 2150,
    category: "Smart Wellness",
    featured: false,
    tests: ["Pap Smear", "HPV Testing"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Anubhav Gupta",
    review: "Very pleasant experience at Nanda Diagnostics for my ultrasound, x-ray and blood reports. Ms. Monika ji at reception is very kind and helpful in guiding throughout the time while testing. Must recommend to everyone looking to get tested for any health reasons.",
    rating: 5,
    source: "Google Review"
  },
  {
    id: 2,
    name: "Shelly Dixit",
    review: "Had my various tests done from here, staff is very courteous and helpful. Neat and clean floors, test labs and rooms. Satisfied with their services and will recommend others also.",
    rating: 5,
    source: "Google Review"
  },
  {
    id: 3,
    name: "Aditi Jain",
    review: "Amazing set of staff. Really helpful reception and the doctor was very calm and professional. She did the ultrasound thoroughly and talked about each of my worries with patience.",
    rating: 5,
    source: "Google Review"
  },
  {
    id: 4,
    name: "Itishree Panda",
    review: "I did level 2 anomaly scan from Dr Nanda, it was indeed a great experience. Sir makes sure you feel comfortable while scan and do a detail scanning taking ample of time. Rest staffs are very polite and helpful.",
    rating: 5,
    source: "Google Review"
  },
  {
    id: 5,
    name: "Saiyam Jain",
    review: "Polite staff, experienced team, supportive towards the patient. Doctor Nanda is so calm and experienced doctor. He takes care of each and every aspect of patients problems. Giving proper time to each and every client.",
    rating: 5,
    source: "Google Review"
  },
  {
    id: 6,
    name: "Surbhi Kaul",
    review: "This has to be the best diagnostic centre in city. Specially if you are looking something for pregnancy ultrasound. The doctors, the staff all are so good and kind. They make you feel so comfortable.",
    rating: 5,
    source: "Google Review"
  },
  {
    id: 7,
    name: "Rupal Wadhwa",
    review: "Great experience at this lab. The staff and the doctor are very calm unlike other places and take their own time to explain the entire process which puts one's mind at ease.",
    rating: 5,
    source: "Google Review"
  },
  {
    id: 8,
    name: "Karan Kashyap",
    review: "Polite staff, skilled team and availability of top of the edge tech. Dr Anupam and his wife are very professional and affable in their approach. Minutely and patiently diagnose their patient even if it takes hour all together.",
    rating: 5,
    source: "Google Review"
  }
];

export const navLinks = [
  { name: "Home", href: "/" },
  { name: "About Us", href: "/about" },
  { name: "Services", href: "/services" },
  { name: "Packages", href: "/packages" },
  { name: "Blogs", href: "/blogs" },
  { name: "Loyalty Program", href: "/loyalty-program" },
  { name: "Downloads", href: "/downloads" },
  { name: "Contact Us", href: "/contact" }
];

// Gallery images - Interior photos only from Nanda Diagnostics
export const galleryImages = [
  {
    id: 1,
    title: "Reception Area",
    category: "Interiors",
    image: "https://nandadiagnostics.com/storage/gallery-images/1702657724.webp"
  },
  {
    id: 2,
    title: "Waiting Lounge",
    category: "Interiors",
    image: "https://nandadiagnostics.com/storage/gallery-images/1702658159.webp"
  },
  {
    id: 3,
    title: "Patient Area",
    category: "Interiors",
    image: "https://nandadiagnostics.com/storage/gallery-images/1702657952.webp"
  },
  {
    id: 4,
    title: "Consultation Room",
    category: "Interiors",
    image: "https://nandadiagnostics.com/storage/gallery-images/1702658163.webp"
  },
  {
    id: 5,
    title: "Collection Area",
    category: "Interiors",
    image: "https://nandadiagnostics.com/storage/gallery-images/1702657790.webp"
  },
  {
    id: 6,
    title: "Lab Reception",
    category: "Interiors",
    image: "https://nandadiagnostics.com/storage/gallery-images/1702657894.webp"
  }
];

// Featured gallery images for homepage and about page (first 4 interior images)
export const featuredGalleryImages = galleryImages.slice(0, 4);
